import * as Cookies from "js-cookie";
import $ from 'jquery';

function favorites() {
    this.add = function(id) {
        if (isNaN(id)) {
            return;
        }
        id = id + '';
        var ids = Cookies.get('favorites');
        if (ids) {
            ids = ids.split(',');
            if (ids.indexOf(id) < 0) {
                ids.push(id);
            }
        } else {
            ids = [id];
        }
        Cookies.set('favorites', ids.join(','));
        $(document).trigger('favoritesAdded', [ids]);
    }
    
    this.remove = function(id) {
        id = id + '';
        var ids = Cookies.get('favorites');
        if (ids) {
            ids = ids.split(',');
            while (ids.indexOf(id) >= 0) {
                ids.splice(ids.indexOf(id), 1);
            }
        } else {
            ids = [];
        }
        Cookies.set('favorites', ids.join(','));
        $(document).trigger('favoritesRemoved', [ids]);
    }
};

export default new favorites; 